export default __webpack_public_path__ + "static/media/AccordianDownBlack.25fe3425.svg";